import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import age18Png from '@/assets/landing-age-selection/lymphatic-walking/age-18.png'
import age40Png from '@/assets/landing-age-selection/lymphatic-walking/age-40.png'
import age50Png from '@/assets/landing-age-selection/lymphatic-walking/age-50.png'
import age60Png from '@/assets/landing-age-selection/lymphatic-walking/age-60.png'

const schema: LandingScreenSchema = {
	order: ['LandingLanguageButton', 'LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		// EN value is 'Lymphatic<br/>walking PLAN'; `uppercase: true` below makes the rendered
		// output identical to the previous hardcoded string.
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('main_walking.lymphatic.age_picker.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		// Four clickable cards, no otherAgesButton — Figma promotes 18-39 out of the escape link
		// and collapses 60-69 + 70+ into a single "60+" card. The 18_39 and 60_plus keys are new
		// (DEV-34967) and join the shared age_range namespace the other two cards already use.
		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-39',
					label: $t('female_yoga.pages.landing.age_range.18_39'),
					img: age18Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: age40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: age50Png,
				},
				{
					// Label follows Figma ("60+"); analyticValue reuses the 60-80 bucket
					// introduced by DEV-34798 so no new analytics value is created.
					value: 60,
					analyticValue: '60-80',
					label: $t('female_yoga.pages.landing.age_range.60_plus'),
					img: age60Png,
				},
			],
		}),
	},
}

export default schema
